<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-arrow-expand-vertical</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.space') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <v-slider
        v-model="content.Size"
        :color="enterpriseColor"
        :label="$t('common.height')"
        min="0"
        max="1000"
        thumb-label
        style="padding-top: 20px"
        @input="handleChangeIsModified"
      />
    </v-toolbar>
  </div>
</template>

<script>
  export default {
    components: {
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      }
    },
    methods: {
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      }
    }
  }
</script>

<style scoped>
</style>

